<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Working Experiences"
      text="Delete working experiences"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="text-center"
            >
              <span class="font-calibri font-18">Are you sure you want to <b class="font-weight-bold font-18"> delete </b> this record?</span>
            </v-col>
          </v-row> 
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      workingExperience: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
      }
    },
    methods: { 
      submitForm () {
        this.progressing = true

        this.$api.hrisWorkingExperiences().delete(this.workingExperience.id)
          .then(response => {
            if (response.status === 200) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })

              this.progressing = false
              this.dialog = false
            }
          })
      },
    },
  }
</script>

<style scoped>
.font-18{
  font-size:18px !important;
}
.font-calibri{
  font-family: calibri ;
}
</style>
